import DocuSignTypes from "../DocuSign/types"
import CaseTypes from "./types"

const INITIAL_STATE = {
  affaires: [],
  affairesCounts: { en_cours: 0, en_retard: 0, en_attente: 0, termine: 0, annule: 0 },
  affaire: {},
  nbAffaireCreatedThisYear: 0,
  models: [],
  works_planning: [],
  capacites: [],
  phaseInfo: {},
}

const MSFReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CaseTypes.POST_AFFAIRE_SUCCESS:
      return {
        ...state,
        affaire: payload,
      }
    case CaseTypes.PATCH_AFFAIRE_SUCCESS:
      return {
        ...state,
        affaire: payload,
      }
    case CaseTypes.PATCH_DATA_AFFAIRE_SUCCESS:
      return {
        ...state,
        phaseInfo: payload,
      }
    case CaseTypes.GET_AFFAIRES_SUCCESS:
      return {
        ...state,
        affaires: payload?.affaires ?? payload,
        affairesCounts: payload?.counts ?? state.affairesCounts,
      }
    case CaseTypes.GET_AFFAIRE_BY_ID_SUCCESS:
      return {
        ...state,
        affaire: payload,
        phaseInfo: payload?.phaseInfo,
      }
    case CaseTypes.GET_NUMBER_OF_AFFAIRES_CREATED_THIS_YEAR_SUCCESS:
      return {
        ...state,
        nbAffaireCreatedThisYear: payload,
      }
    case CaseTypes.GET_LINE_NAME_BY_CODE_SUCCESS:
      return {
        ...state,
        lineName: payload,
      }
    case CaseTypes.CLEAR_LINE_NAME:
      return {
        ...state,
        lineName: null,
      }
    case CaseTypes.GET_WORKS_PLANNING_SUCCESS:
      return {
        ...state,
        works_planning: payload,
      }
    case CaseTypes.GET_CAPACITES_SUCCESS:
      return {
        ...state,
        capacites: payload,
      }
    case CaseTypes.GET_MODELS_SUCCESS:
      return {
        ...state,
        models: payload,
      }
    case DocuSignTypes.GET_DOCUSIGN_AUTH_URL_SUCCESS:
      return {
        ...state,
        docuSignAuthUrl: payload,
      }
    case DocuSignTypes.GET_DOCUSIGN_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        docuSignAccessToken: payload,
        docuSignAuthUrl: undefined,
      }
    default:
      return state
  }
}

export default MSFReducer
